module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<h2 class=\"video-section-title\">\n    <% if (typeof title !== 'undefined') { %><%= title %><% } %>\n    <% if (typeof redDot !== 'undefined' && redDot === true) { %>\n        <div class=\"reddot\"></div>\n    <% } %> \n    <% if (typeof todaysDate !== 'undefined') { %>\n        <span class=\"schedule-header-date\" style=\"display: none;\">Today <%=  todaysDate %></span><%\n    } %>\n</h2>\n\n<% // START A/B TEST PLGRWEB-1558 Live Sports Data Carousel %>\n<% if (typeof liveSportsDataEnabled !== 'undefined') { %>\n    <% if (displayScoresToggle) { %>\n        <div id=\"scores-toggle-wrapper\" class=\"scores-toggle-wrapper\">\n            <label class=\"scores-toggle-label\">Scores</label>\n            <button type=\"button\" tabindex=\"0\" id=\"switch-scores-toggle\"\n                    class=\"switch-scores-toggle\">\n                <span class=\"switch-scores-toggle-knob\"></span>\n            </button>\n            <span class=\"tooltip hide-tooltip\">\n                <div class=\"tooltip-bold\">New!</div>\n                <div class=\"tooltip-regular\">Show live scores</div>\n                <div class=\"tooltip-close-out\"></div>\n            </span>\n        </div>\n    <% } %>\n<% } %>\n<% // END A/B TEST PLGRWEB-1558 Live Sports Data Carousel %>\n\n<% if (typeof editable !== 'undefined') { %>\n<div class=\"edit-carousel\" tabindex=\"0\">\n    <%= getLocale('edit') %>\n</div>\n<div class=\"edit-cancel-carousel\">\n    <%= getLocale('cancel') %>\n</div>\n<% } %>\n\n\n<ul class=\"dropdown dropdown__filter js-dropdown\"></ul>\n<div class=\"video-carousel-box\" <% if (typeof pvrModel !== 'undefined') { %> data-pvrModel=\"<%= pvrModel %>\" <% } %> >\n    <div class=\"wrap swiper-container\">\n        <div class=\"carousel-container swiper-wrapper\">\n        </div>\n        <a class=\"carousel-prev focusable\"></a>\n        <a class=\"carousel-next focusable\"></a>\n    </div>\n    <div class=\"message-box\"></div>\n</div>"
  , __filename = "node_modules/.pnpm/git+github.com+cbsi-cbscom+web-package-coreui@35438e80bafb63735c34769877496d6d13d02092_fetch-_5cl4lt2j4h4pcddd4fizyg5kaq/node_modules/cbs-core-ui/src/js/templates/carousels/layout.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<h2 class=\"video-section-title\">\n    ")
    ; __line = 2
    ;  if (typeof title !== 'undefined') { 
    ; __append(escapeFn( title ))
    ;  } 
    ; __append("\n    ")
    ; __line = 3
    ;  if (typeof redDot !== 'undefined' && redDot === true) { 
    ; __append("\n        <div class=\"reddot\"></div>\n    ")
    ; __line = 5
    ;  } 
    ; __append(" \n    ")
    ; __line = 6
    ;  if (typeof todaysDate !== 'undefined') { 
    ; __append("\n        <span class=\"schedule-header-date\" style=\"display: none;\">Today ")
    ; __line = 7
    ; __append(escapeFn(  todaysDate ))
    ; __append("</span>")
    ; 
    } 
    ; __line = 8
    ; __append("\n</h2>\n\n")
    ; __line = 11
    ;  // START A/B TEST PLGRWEB-1558 Live Sports Data Carousel 

    ; __append("\n")
    ; __line = 12
    ;  if (typeof liveSportsDataEnabled !== 'undefined') { 
    ; __append("\n    ")
    ; __line = 13
    ;  if (displayScoresToggle) { 
    ; __append("\n        <div id=\"scores-toggle-wrapper\" class=\"scores-toggle-wrapper\">\n            <label class=\"scores-toggle-label\">Scores</label>\n            <button type=\"button\" tabindex=\"0\" id=\"switch-scores-toggle\"\n                    class=\"switch-scores-toggle\">\n                <span class=\"switch-scores-toggle-knob\"></span>\n            </button>\n            <span class=\"tooltip hide-tooltip\">\n                <div class=\"tooltip-bold\">New!</div>\n                <div class=\"tooltip-regular\">Show live scores</div>\n                <div class=\"tooltip-close-out\"></div>\n            </span>\n        </div>\n    ")
    ; __line = 26
    ;  } 
    ; __append("\n")
    ; __line = 27
    ;  } 
    ; __append("\n")
    ; __line = 28
    ;  // END A/B TEST PLGRWEB-1558 Live Sports Data Carousel 

    ; __append("\n\n")
    ; __line = 30
    ;  if (typeof editable !== 'undefined') { 
    ; __append("\n<div class=\"edit-carousel\" tabindex=\"0\">\n    ")
    ; __line = 32
    ; __append(escapeFn( getLocale('edit') ))
    ; __append("\n</div>\n<div class=\"edit-cancel-carousel\">\n    ")
    ; __line = 35
    ; __append(escapeFn( getLocale('cancel') ))
    ; __append("\n</div>\n")
    ; __line = 37
    ;  } 
    ; __append("\n\n\n<ul class=\"dropdown dropdown__filter js-dropdown\"></ul>\n<div class=\"video-carousel-box\" ")
    ; __line = 41
    ;  if (typeof pvrModel !== 'undefined') { 
    ; __append(" data-pvrModel=\"")
    ; __append(escapeFn( pvrModel ))
    ; __append("\" ")
    ;  } 
    ; __append(" >\n    <div class=\"wrap swiper-container\">\n        <div class=\"carousel-container swiper-wrapper\">\n        </div>\n        <a class=\"carousel-prev focusable\"></a>\n        <a class=\"carousel-next focusable\"></a>\n    </div>\n    <div class=\"message-box\"></div>\n</div>")
    ; __line = 49
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git+github.com+cbsi-cbscom+web-package-coreui@35438e80bafb63735c34769877496d6d13d02092_fetch-_5cl4lt2j4h4pcddd4fizyg5kaq/node_modules/cbs-core-ui/src/js/templates/carousels/layout.tpl"

}